import React from 'react';
import { Box } from '@mui/material';

const AppBackground: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100lvh',
        zIndex: -1,
      }}
    >
      <img
        src="/bg.png"
        alt="Background"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(5px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
        }}
      />
    </Box>
  );
};

export default AppBackground;